<template>
  <div id="app" ref="app" >
    <!-- <div class="pos"></div> -->
    <!-- <transition :name="direction"> -->
    <!-- <keep-alive include="Home"> -->
      <router-view />
    <!-- </keep-alive> -->
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  name: "App",

  created() {

    SmartCity.hideTopView({
            isShow: 0,
        });
  },
};
</script>
<style lang="less">
#app {
  color: #333;
  font-size: 14px;
  // min-height: 100%;
  height: 100vh;
}

#app::-webkit-scrollbar {
  display: none;
}
.pos {
  height: 1vh;
}
</style>
